import { Injectable } from '@angular/core';
@Injectable({
    providedIn: 'root',
})
export class SassHelpersService {
    private _bodyBreakpointsHardcodeForServer = {
        '--break-mini-mobile': '330px',
        '--break-mobile': '480px',
        '--break-middle': '768px',
        '--break-narrow': '880px',
        '--break-normal': '1120px',
        '--break-wide': '1400px',
    };

    public readProperty(name: string, prefix: string = ''): string {
        return this._bodyBreakpointsHardcodeForServer[(prefix + name) as keyof typeof this._bodyBreakpointsHardcodeForServer];
        // return AppGlobalsModule.isServer ? this._bodyBreakpointsHardcodeForServer[prefix + name] : this._bodyStyles.getPropertyValue(prefix + name)
    }
}
